import { FC, useContext } from 'react';

import { useMutation } from '@apollo/client';
import { Button, H2, Modal, Paragraph } from '@smartshell/ui-kit';

import { LOGOUT_ALL, ILogoutAllResponse, AuthContext } from 'auth';
import { LocalizationContext } from 'localization';
import notificationService from 'services/notificationService';

import s from './LogoutAllModal.module.scss';

export const LogoutAllModal: FC<{ onClose: VoidFunction }> = ({ onClose }) => {
  const { t } = useContext(LocalizationContext);
  const {
    actions: { logout },
  } = useContext(AuthContext);

  const [logoutAll] = useMutation<ILogoutAllResponse>(LOGOUT_ALL, {
    onCompleted: (data) => {
      if (!data.logoutAll) {
        notificationService.info({
          t,
          type: 'error',
          title: t('errors.error'),
        });
      } else {
        logout();
      }
      onClose();
    },
    onError: () => {
      notificationService.info({
        t,
        type: 'error',
        title: t('errors.error'),
      });
      onClose();
    },
  });

  return (
    <Modal className={s.container} onClose={onClose}>
      <H2 className={s.title}>{t('logout.all.modal.title')}</H2>
      <Paragraph className={s.description} bold color="secondary">
        {t('logout.all.modal.description')}
      </Paragraph>
      <div className={s.buttons}>
        <Button color="red" fullWidth onClick={() => logoutAll()}>
          {t('logout')}
        </Button>
        <Button onClick={onClose} fullWidth>
          {t('cancel')}
        </Button>
      </div>
    </Modal>
  );
};
